import React from 'react';

function Portfolio({ resumeData }) {
  if (!resumeData) {
    return null;
  }

  const { work, portfolio, skills } = resumeData;

  return (
    <>
      {/* Work Experience Section */}
      {work && work.length > 0 && (
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Work</span></h1>
          </div>
          <div className="nine columns main-col">
            {work.map((job, index) => (
              <div key={index} className="row item">
                <div className="twelve columns">
                  <h3>{job.company}</h3>
                  <p className="info">
                    {job.title} <span>•</span> <em className="date">{job.years}</em>
                  </p>
                  {job.description && <p>{job.description}</p>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Portfolio Section */}
      {portfolio && portfolio.projects && portfolio.projects.length > 0 && (
        <section id="portfolio">
          <div className="row">
            <div className="twelve columns collapsed">
              <h1>Check Out Some of My Works.</h1>
              <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
                {portfolio.projects.map((project, index) => (
                  <div key={index} className="columns portfolio-item">
                    <div className="item-wrap">
                      <a href={`#modal-0${index + 1}`} title={project.title}>
                        <img alt={project.title} src={project.image} />
                        <div className="overlay">
                          <div className="portfolio-item-meta">
                            <h5>{project.title}</h5>
                          </div>
                        </div>
                        <div className="link-icon"><i className="icon-plus" /></div>
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {/* Modal Popups */}
              {portfolio.projects.map((project, index) => (
                <div key={index} id={`modal-0${index + 1}`} className="popup-modal mfp-hide">
                  <img className="scale-with-grid" src={project.image} alt={project.title} />
                  <div className="description-box">
                    <h4>{project.title}</h4>
                    {project.category && (
                      <p className="project-category" style={{ fontStyle: 'italic', color: '#888', marginBottom: '10px' }}>
                        {project.category}
                      </p>
                    )}
                    {project.description && <p>{project.description}</p>}
                    <span className="categories"><i className="fa fa-tag" /></span>
                  </div>
                  <div className="link-box">
                    <a href={project.url} target="_blank" rel="noopener noreferrer">APP DEMO</a>
                    <a href={project.github} target="_blank" rel="noopener noreferrer">GITHUB REPO</a>
                    {project.githubBackend && (
                      <a href={project.githubBackend} target="_blank" rel="noopener noreferrer">Back-End GITHUB REPO</a>
                    )}
                    <a href={`#${project.title.toLowerCase().replace(/\s+/g, '-')}`} className="popup-modal-dismiss">Close</a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Skills Section */}
      {skills && (
        <div className="row skill">
          <div className="three columns header-col">
            <h1><span>Skills</span></h1>
          </div>
          <div className="nine columns main-col">
            {skills.description && <p>{skills.description}</p>}
            {skills.list && skills.list.length > 0 && (
              <div className="bars">
                <ul className="skills">
                  {skills.list.map((skill, index) => (
                    <li key={index}>
                      <span className={`bar-expand ${skill.className}`} />
                      <em>{skill.name}</em>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Portfolio;
